import { useEffect } from 'react';
import { useAuthStore } from '@/store/authStore';
import { 
  getRouteConfig, 
  startOnboardingForRoute,
  resetOnboarding 
} from '@/lib/onboardingTours/driver';

/**
 * Component that exposes onboarding helper functions to window for development/testing.
 */
export function OnboardingDevTools() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Bind testOnboarding helper for manual testing in console
    window.testOnboarding = async (userId?: string) => {
      const testUserId = userId || 'test-user';
      const pathname = window.location.pathname;
      const roles = useAuthStore.getState().roles || [];
      
      const routeConfig = getRouteConfig(pathname, roles);
      if (routeConfig) {
        await resetOnboarding(routeConfig.processName, testUserId).catch((error) => {
          console.error('[Onboarding] Failed to reset onboarding:', error);
        });
        console.log('[Onboarding] Reset', routeConfig.processName, 'complete, starting tour...');
        startOnboardingForRoute(routeConfig, testUserId, pathname);
      } else {
        console.warn('[Onboarding] No route configuration found for path:', pathname);
      }
    };
    
    // Bind checkOnboardingElements helper for debugging
    window.checkOnboardingElements = () => {
      const alertTabs = document.querySelector('[data-onboarding="alert-tabs"]');
      const newAlerts = document.querySelector('[data-onboarding="new-alerts"]');
      const assignedAlerts = document.querySelector('[data-onboarding="assigned-alerts"]');
      
      console.log('[Onboarding] Element check:', {
        alertTabs: !!alertTabs,
        newAlerts: !!newAlerts,
        assignedAlerts: !!assignedAlerts,
        pathname: window.location.pathname,
      });
      
      return { alertTabs, newAlerts, assignedAlerts };
    };

    // Cleanup on unmount
    return () => {
      delete window.testOnboarding;
      delete window.checkOnboardingElements;
    };
  }, []);

  return null;
}

declare global {
  interface Window {
    testOnboarding?: (userId?: string) => Promise<void>;
    checkOnboardingElements?: () => {
      alertTabs: Element | null;
      newAlerts: Element | null;
      assignedAlerts: Element | null;
    };
  }
}
